import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

const PersonalData = () => {
    const { t } = useTranslation(['personalData']);
    const data = t('body');
    const getSanitizedData = () => ({
        __html: DOMPurify.sanitize(data)
      });
    
    return (
        <div 
        dangerouslySetInnerHTML={getSanitizedData()}
        />
    );
};

export { PersonalData };